/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDistrictCommand } from '../../models/create-district-command';
import { CreateDistrictCommandResult } from '../../models/create-district-command-result';

export interface ApiDistrictCreateDistrictPost$Params {
      body?: CreateDistrictCommand
}

export function apiDistrictCreateDistrictPost(http: HttpClient, rootUrl: string, params?: ApiDistrictCreateDistrictPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateDistrictCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictCreateDistrictPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateDistrictCommandResult>;
    })
  );
}

apiDistrictCreateDistrictPost.PATH = '/api/District/CreateDistrict';
